package com.ives.components.slider;

import com.er453r.hxcompo.Component;
import js.Browser;

class Slider extends Component{
	public static inline var CLOSE:String = "closeSlider";

	private var selector:String;

	private var closeListener:Void->Void;

	public function new(content:Component) {
		on(closeButton, "click", close);

		on(CLOSE, close);

		append(content);
	}

	public function open(selector:String, ?closeListener:Void->Void){
		this.selector = selector;
		this.closeListener = closeListener;

		Browser.document.querySelector(selector).appendChild(view);
	}

	public function close(){
		on(slider, "animationend", cleanup);
		slider.classList.add("hide");

		this.viewElement.classList.add("hide");

		if(closeListener != null)
			closeListener();
	}

	private function cleanup(){
		view.remove();
	}
}
